<div class="popup-background flex justify-content-center align-items-center">
  <div #innerPopup class="popup-box background-white flex-column">
    <div class="flex">
      <div style="height: 35.4rem" class="flex flex-1 w-100">
        <app-ship-from
          [isEdit]="isEditingAvailable"
          [name]="innerLocationData.name"
          [address]="innerLocationData.address"
          (nameChange)="updateName($event)"
          (addressChange)="updateAddress($event)"
        ></app-ship-from>
      </div>
      <div style="height: 35.4rem" class="flex flex-1 w-100">
        <app-working-hours
          [isEdit]="isEditingAvailable"
          [workingHours]="getWorkingHoursArray()"
          (workingHoursChange)="updateWorkingHours($event)"
        ></app-working-hours>
      </div>
      <div style="height: 35.4rem" class="flex flex-1 w-100 position-relative">
        <app-gates-section [isEdit]="isEditingAvailable" [(gates)]="innerLocationData.gates"></app-gates-section>
        <div
          *ngIf="!isEditingAvailable"
          (click)="toggleIsEditingAvailable($event)"
          class="position-absolute edit-button button-round-large color-dark-blue font--xxl-14 background-turquoise--dark border-z-green flex align-items-center justify-content-center"
        >
          Edit
        </div>
      </div>
    </div>
    <div class="popup-box-buttons flex justify-content-end align-items-center">
      <div
        *ngIf="!isEditingAvailable"
        (click)="closePopup()"
        class="margin-xxl--right-30 font--xxl-14 color-dark-blue cursor-pointer"
      >
        Close
      </div>
      <div
        *ngIf="isEditingAvailable"
        (click)="closePopup()"
        class="margin-xxl--right-30 font--xxl-14 color-dark-blue cursor-pointer"
      >
        Cancel
      </div>
      <div
        *ngIf="isEditingAvailable"
        (click)="saveInnerLocation()"
        class="button-round-medium color-dark-blue font--xxl-14 background-turquoise--dark border-z-green margin-xxl--left-18 flex align-items-center justify-content-center"
      >
        Save
      </div>
    </div>
  </div>
</div>
